import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { PLEINE_LARGEUR, STACK_SCREEN_OPTIONS } from './screenOptions';
import { SUR_LE_WEB } from '../theme/tokens';
import { destinationEnAttente } from './destinationWeb';
import { OnboardingScreen } from '../screens/OnboardingScreen';
import { AuthScreen } from '../screens/AuthScreen';
import { TermsScreen } from '../screens/TermsScreen';
import { PrivacyScreen } from '../screens/PrivacyScreen';

export type OnboardingStackParamList = {
  Onboarding: undefined;
  Auth: { mode?: 'signin' | 'signup'; profil?: string } | undefined;
  Terms: undefined;
  Privacy: undefined;
};

const Stack = createNativeStackNavigator<OnboardingStackParamList>();

export function OnboardingNavigator() {
  /**
   * ARRIVÉE PAR L'URL D'UN ÉCRAN PROTÉGÉ, SANS SESSION → la pile démarre sur la CONNEXION.
   *
   * DÉCLARATIF, ET NON UNE NAVIGATION IMPÉRATIVE — le premier essai passait par
   * `navigationRef.reset()` depuis `onReady`, et perdait la course contre la résolution initiale
   * des liens du conteneur : mesuré, l'URL redevenait `/bienvenue` et l'écran d'accroche restait
   * affiché. Choisir la route INITIALE règle l'ordre au lieu de lutter contre lui.
   *
   * Sans destination en attente — visite ordinaire — la pile démarre sur l'accroche, comme avant.
   * `destinationEnAttente` rend `false` hors du web : le mobile ne voit pas cette ligne.
   */
  const initiale = destinationEnAttente() ? 'Auth' : 'Onboarding';

  return (
    <Stack.Navigator initialRouteName={initiale} screenOptions={STACK_SCREEN_OPTIONS}>
      <Stack.Screen name="Onboarding" options={SUR_LE_WEB ? PLEINE_LARGEUR : undefined}>
        {({ navigation }) => (
          <OnboardingScreen
            onCreateAccount={() => navigation.navigate('Auth', { mode: 'signup' })}
            onSignIn={() => navigation.navigate('Auth', { mode: 'signin' })}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="Auth" options={SUR_LE_WEB ? PLEINE_LARGEUR : undefined}>
        {({ route, navigation }) => (
          <AuthScreen
            initialMode={route.params?.mode}
            profil={route.params?.profil}
            // Pas de retour quand la connexion est la première page (arrivée par l'URL d'un écran
            // protégé) : il n'y aurait nulle part où aller.
            onBack={navigation.canGoBack() ? () => navigation.goBack() : undefined}
            onOpenTerms={() => navigation.navigate('Terms')}
            onOpenPrivacy={() => navigation.navigate('Privacy')}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="Terms">
        {({ navigation }) => (
          <TermsScreen onBack={() => navigation.goBack()} onOpenPrivacy={() => navigation.navigate('Privacy')} />
        )}
      </Stack.Screen>
      <Stack.Screen name="Privacy">
        {({ navigation }) => (
          <PrivacyScreen onBack={() => navigation.goBack()} onOpenTerms={() => navigation.navigate('Terms')} />
        )}
      </Stack.Screen>
    </Stack.Navigator>
  );
}
